import api from "@/services/api"

export type LogInAsSupervisorPayload = {
  pin: string
}

export const logInAsSupervisor = async (
  payload: LogInAsSupervisorPayload
): Promise<{ accessToken: string }> => {
  const { body } = await api.post<{ accessToken: string }>(
    "/auth/app/supervisor-login/",
    { body: payload }
  )
  return body
}
